import { render } from "./debitor-receipt.vue?vue&type=template&id=6eee1308&scoped=true"
import script from "./debitor-receipt.vue?vue&type=script&lang=js"
export * from "./debitor-receipt.vue?vue&type=script&lang=js"

import "./debitor-receipt.vue?vue&type=style&index=0&id=6eee1308&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6eee1308"]])

export default __exports__